import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Container } from 'reactstrap';
import { showNotification, successNofication } from 'src/shared/components/Notification'
import PndRestApi from 'src/utils/pnd/PndRestApi';
import AddOrUpdateClientDetails from './components/AddOrUpdateClientDetails';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import { LinearProgress } from '@mui/material';

const ClientView = () => {

  useEffect(() => {

    // Calculate today's date
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0, so we add 1
    const day = String(today.getDate()).padStart(2, '0');

    // Format the date as YYYY-MM-DD
    const formattedDate = `${year}-${month}-${day}`;
    setToday(formattedDate);
    const nextYear = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());

    // Subtract one day from the next year date
    nextYear.setDate(nextYear.getDate() - 1);

    // Format the date as YYYY-MM-DD
    const year1 = nextYear.getFullYear();
    const month1 = String(nextYear.getMonth() + 1).padStart(2, '0'); // January is 0, so we add 1
    const day1 = String(nextYear.getDate()).padStart(2, '0');

    const formattedDate1 = `${year1}-${month1}-${day1}`;
    setOneYearLate(formattedDate1);
    getComServerConfiguration();
    //getPlanDetails();

  }, [])

  //const [data, setData] = useState([]);
  const [isComServerData, setComServerData] = useState([]);
  const [isMapData, setMapData] = useState(null);
  const [isRedirect, setIsRedirect] = useState(false);
  const [isToday, setToday] = useState(null);
  const [isOneYearLate, setOneYearLate] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [paymentPlanOptions, setPaymentPlanOptions] = useState([]);
  // const [subscriptionPlanOptions, setSubscriptionPlanOptions] = useState([]);
  if (isRedirect) {
    return <Redirect to="/web_app/pnd_establishment/view" />;
  }

  // const getPlanDetails = async () => {
  //   try {
  //     setLoading(true);

  //     const response = await PndRestApi.GetSubscriptionAndPaymentPlan();
  //     if (response.status === 200 && response.data.status === 200) {
  //       if (response?.data?.data?.customerPaymentPlans) {
  //         const paymentPlanOptions = response.data.data.customerPaymentPlans.map(plan => ({
  //           value: plan.paymentPlanId, // Adjust according to your data structure
  //           label: plan.planName // Adjust according to your data structure
  //         }));
  //         setPaymentPlanOptions(paymentPlanOptions);
  //       }
  //       if (response?.data?.data?.customerSubscriptionPlans) {
  //         const subscriptionPlanOptions = response.data.data.customerSubscriptionPlans.map(plan => ({
  //           value: plan.subscriptionPlanId, // Adjust according to your data structure
  //           label: plan.planName + " (" + plan.allowingCount + ") " // Adjust according to your data structure
  //         }));
  //         setSubscriptionPlanOptions(subscriptionPlanOptions);
  //       }
  //     }
  //     else {
  //       showNotification(
  //         "theme-light",
  //         "ltr",
  //         `SuccessCode: ${response.data.status}`,
  //         `Message:${response.data.message}`,
  //       );
  //       return;
  //     }
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //     showNotification(
  //       "theme-light",
  //       "ltr",
  //       `SuccessCode: 500`,
  //       ERROR_MESSAGES.tryCatchError,
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const getComServerConfiguration = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.GetComServerConfiguration();
      if (response.status === 200 && response.data.status === 200) {
        setComServerData(response.data.data);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response?.data?.status}`,
          `Message: ${response?.data?.message}`,
        );
      }

    } catch (error) {
      console.log("Error in getComServerConfiguration", error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        `Message:Something went wrong. Please try again later.`,
      );
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit = async (formValues) => {

    try {
      // formValues["operationType"] = 1;
      formValues["status"] = formValues.status ? 1 : 0;
      // if (formValues.dateRange !== undefined) {
      formValues["subscriptionStartDate"] = isToday;
      formValues["subscriptionEndDate"] = isOneYearLate;
      // }
      // if (formValues.communicationType !== undefined) {
      //     formValues["communicationType"] = formValues.communicationType.map(option => option.value).join(', ');
      // }
      formValues["communicationType"] = 1;
    
      formValues["customerSubscriptionPlanInfo"] = {
        subscriptionPlanId: formValues["customerSubscriptionPlanInfo"]["value"],
      };
      formValues["timeZoneInfo"] = {
        timeZoneId: formValues["timeZoneInfo"] ? formValues["timeZoneInfo"]["value"] : null,
      }

      formValues["customerPaymentPlanInfo"] = {
        paymentPlanId: formValues["customerPaymentPlanInfo"]["value"],
      };
      
      
      if (formValues.supportingServices !== undefined) {
        formValues["supportingServices"] = formValues.supportingServices.map(option => option.value).join(', ');
        // Split the string into individual values using comma as delimiter
        if (formValues["supportingServices"].includes(1)) {
          formValues["isPickUp"] = true;
        } else {
          formValues["isPickUp"] = false;
        }
        if (formValues["supportingServices"].includes(2)) {
          formValues["isDropOff"] = true;
        } else {
          formValues["isDropOff"] = false;
        }
        if (formValues["supportingServices"].includes(3)) {
          formValues["isPnd"] = true;
        } else {
          formValues["isPnd"] = false;
        }

        formValues.dateRange = null;
      }
      //let deliveryAddress = "";

      if (isMapData) {
        formValues["clientAddress"] = isMapData;
      }


      const response = await PndRestApi.AddOrUpdateInformapClientDetails(formValues);
      if (response.status === 200 && response.data.status === 200) {
        successNofication(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          ERROR_MESSAGES.successMessage,
        );
        setTimeout(() => {
          setIsRedirect(true);
        }, 2000);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    }
  };

  return (
    <Container>
      {loading && <LinearProgress color="primary" /> }
      <AddOrUpdateClientDetails onSubmit={handleSubmit} isComServerData={isComServerData} setMapData={setMapData} isToday={isToday} isOneYearLate={isOneYearLate} />
    </Container>
  );
};

export default ClientView;